const i18n = require("@/i18n");

module.exports = {
  id: "Stylable_StylableButton_2",
  preset: { rect: { width: 162, height: 75, x: 0, y: 75 }, tags: null },
  structure: {
    parent: "comp-knzvqsjj",
    style: {
      styleType: "custom",
      componentClassName: "wixui.StylableButton",
      style: {
        groups: {},
        properties: {
          "$st-css":
            ":import{\n    -st-from: 'wix-ui-santa/index.st.css';\n    -st-named: StylableButton\n}\n.root{\n    -st-extends: StylableButton;\n    transition: all 0.2s ease, visibility 0s;\n    padding: 3px;\n    background: #0B2F5B;\n    box-shadow:;\n    /*inset 3.54px 3.54px 0 -64px value(site_1_1)*/ border: 4px double value(site_1_1)\n}\n.root:hover{\n    background: value(site_1_1);\n    border: 3px double rgb(11, 47, 91)\n}\n.root:hover::label{\n    color: value(site_1_5)\n}\n.root:disabled{\n    background: #E2E2E2\n}\n.root:disabled::label{\n    color: #8F8F8F\n}\n.root:disabled::icon{\n    fill: #8F8F8F\n}\n.root::container{\n    transition: inherit\n}\n.root::label{\n    transition: inherit;\n    color: value(site_1_1);\n    font-weight: normal;\n    font-style: normal;\n    font-family: \"playfair display\",serif;\n    font-size: 17px;\n    display: initial;\n    letter-spacing: 0.15em\n}\n.root::icon{\n    transition: inherit;\n    width: 10px;\n    height: 10px;\n    fill: value(site_1_1);\n    display: none\n}\n.root:hover::icon{\n    fill: value(site_1_5)\n}",
        },
        propertiesSource: { "$st-css": "value" },
      },
      pageId: "",
      compId: "",
      type: "ComponentStyle",
      metaData: {
        isHidden: false,
        sig: "ybj-2314",
        pageId: "c1dmp",
        schemaVersion: "1.0",
        isPreset: false,
      },
      skin: "wixui.skins.Skinless",
    },
    activeModes: {},
    data: {
      type: "StylableButton",
      metaData: {
        isHidden: false,
        sig: "ybj-2362",
        pageId: "c1dmp",
        schemaVersion: "1.0",
        isPreset: false,
      },
      label: i18n.translate("buttons_text_preset_send"),
      svgId: "b861b040274141de9c08999ec3b76edf.svg",
    },
    components: [],
    componentType: "wixui.StylableButton",
    id: "comp-klz3ta13",
    layout: {
      x: 10,
      fixedPosition: false,
      y: 91,
      scale: 1,
      height: 45,
      rotationInDegrees: 0,
      width: 137,
    },
    type: "Component",
    props: {
      type: "StylableButtonProperties",
      metaData: { schemaVersion: "1.0", sig: "mtq-2381", pageId: "c1dmp" },
    },
    metaData: { sig: "ybj-2316", pageId: "c1dmp" },
    skin: "wixui.skins.Skinless",
  },
};
